<!-- Доменная конфигурация общего прогресса ЭЗЗ. -->
<template>
  <EdoDocumentFlowDetails
    :flow="flow"
    :title-details="titleDetails"
    :read-only="readOnly"
    :inspectable="inspectable"
    :variant="variant"
    title="Информация по этапам ЭЗЗ"
    :guides="stepGuides"
    :fallback-guide="fallbackGuide"
    @title-action="$emit('title-action', $event)"
  />
</template>

<script>
import {
  TRANSPORT_ORDER_FALLBACK_GUIDE,
  TRANSPORT_ORDER_STEP_GUIDES,
} from "@/components/Edo/TransportOrder/flowConfig";
import EdoDocumentFlowDetails from "@/components/Edo/shared/EdoDocumentFlowDetails.vue";

export default {
  name: "EdoTransportOrderFlowDetails",

  emits: ["title-action"],

  components: {
    EdoDocumentFlowDetails,
  },

  props: {
    flow: {
      type: Object,
      default: null,
    },
    titleDetails: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    inspectable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator: (value) => ["card", "embedded", "flat"].includes(value),
    },
  },

  computed: {
    stepGuides() {
      return TRANSPORT_ORDER_STEP_GUIDES;
    },

    fallbackGuide() {
      return TRANSPORT_ORDER_FALLBACK_GUIDE;
    },
  },
};
</script>
